import React from "react";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import IconCross from "#library/assets/icons/jds_cross.svg";
import { useModal } from "#library/components/Modal/ModalManagement/ModalContext";
import styles from "#library/components/Modal/modal.module.css";
export var CloseButton = function CloseButton() {
  var _useModal = useModal(),
    onClose = _useModal.onClose;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles["jds-Modal__closeButton"],
    "aria-label": "close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    size: ICON_SIZES.MEDIUM,
    xlinkHref: "#".concat(IconCross.id),
    "aria-hidden": "true"
  }));
};